import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './views/login/login.component';

// Import Containers
import { FullLayoutComponent, SimpleLayoutComponent, CashierLayoutComponent } from './containers';
import { AuthGuard } from './guards/auth/auth.guard';
import { PermissionGuard } from './guards/permission/permission.guard';
import { HomeRedirectGuard } from './guards/home-redirect/home-redirect.guard';
import { CashierOnlyRedirectGuard } from './guards/cashier-only/cashier-only-redirect.guard';

export const routes: Routes = [
  {
    // Alamat akar: kasir-saja ke /cashier, akun lain ke /dashboard (belum login: /login).
    path: '',
    pathMatch: 'full',
    canActivate: [HomeRedirectGuard],
    children: [],
  },
  {
    // Layar kasir (dulu aplikasi Cashpay terpisah). Layout tanpa sidebar.
    path: 'cashier',
    component: CashierLayoutComponent,
    data: {
      title: 'Kasir',
      permissions: ['cashpay.use'],
    },
    canActivate: [AuthGuard, PermissionGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/cashier/cashier.module').then((m) => m.CashierModule),
      },
    ],
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'registration',
        loadChildren: () =>
          import('./views/registration/registration.module').then(
            (m) => m.RegistrationModule
          ),
      },
      {
        path: 'checkin',
        loadChildren: () =>
          import('./views/checkin/checkin.module').then((m) => m.CheckinModule),
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./views/payment/payment.module').then((m) => m.PaymentModule),
      },
      {
        path: 'leads',
        loadChildren: () =>
          import('./views/leads/leads.module').then((m) => m.LeadsModule),
      },
      {
        path: 'penjemputan',
        loadChildren: () =>
          import('./views/penjemputan/penjemputan.module').then(
            (m) => m.PenjemputanModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./views/report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'academic',
        loadChildren: () =>
          import('./views/academic/academic.module').then(
            (m) => m.AcademicModule
          ),
      },
      {
        path: 'camp',
        loadChildren: () =>
          import('./views/camp/camp.module').then((m) => m.CampModule),
      },
      {
        path: 'ac-rooms',
        loadChildren: () =>
          import('./views/ac/ac.module').then((m) => m.AcModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./views/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./views/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
    ],
    canActivate: [AuthGuard, CashierOnlyRedirectGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
